import cn from 'classnames'
import { HTMLAttributes } from 'react'

import styles from './FormFieldHint.module.scss'

type FormFieldHintProps = HTMLAttributes<HTMLDivElement>

const FormFieldHint = ({ children, className, ...props }: FormFieldHintProps) => {
  return (
    <div className={cn(styles.signupFieldErr, className)} {...props}>
      {children}
    </div>
  )
}

export default FormFieldHint
